import SnakePath from './SnakePath'
import ValueCards from './ValueCards'

export default function ValueSection() {
  return (
    <section className="relative rounded-section bg-oak-cream">
      <SnakePath />
      <ValueCards />
    </section>
  )
}
